//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import pop from '@/mixin/pop';
export default {
  mixins: [pop],
  computed: {
    hasWin: function hasWin() {
      return this.options.type === 1;
    }
  },
  props: {
    options: {
      type: Object,
      default: null
    }
  }
};